import { element } from '@angular/core/src/render3';
import { MapsketchdialogComponent } from './../../dialogs/mapsketchdialog/mapsketchdialog.component';
import { MapdialogComponent } from './../../dialogs/mapdialog/mapdialog.component';
import { TicketCode } from './../../shared/ticket';
import { MatDialogRef } from '@angular/material';
import { SearchMapComponent } from './../searchMap/searchMap.component';
import { InfodialogComponent } from '../../dialogs/infodialog/infodialog.component';
import { SketchbyxydialogComponent } from '../../dialogs/sketchbyxydialog/sketchbyxydialog.component';

import { MatDialog, MatMenuTrigger } from '@angular/material';
import { MapService } from './../../shared/map.service';
import { AuthenticationService } from './../../shared/authentication.service';
import { Extension, Feature, RootObject, MapNote } from './../../shared/mapsearchresults.model';
import { MapPolygon, CodeDiffDisplay, NewWorkArea } from './../../shared/map.model';
import { Component, OnInit, ViewChild, EventEmitter, Output } from '@angular/core';
import { LocalStorage } from '../../shared/localstorage.service';
import { TicketService } from '../../shared/ticketService';
import { } from 'googlemaps';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-googlemap',
  templateUrl: './googlemap.component.html',
  styleUrls: ['./googlemap.component.scss']
})

export class GooglemapComponent implements OnInit {

  @ViewChild('gmap') gmapElement: any;
  @ViewChild('menuTrigger') trigger: MatMenuTrigger;
  @ViewChild('rightClickMenuTrigger') rightClickMenuTrigger: MatMenuTrigger;
  @Output() workAreaChange: EventEmitter<NewWorkArea> = new EventEmitter<NewWorkArea>();

  map: google.maps.Map;
  workAreaPolygon: MapPolygon;
  searchPolygons: MapPolygon[] = [];
  searchMarkers: google.maps.Marker[] = [];
  searchPolilines: google.maps.Polyline[] = [];
  private mapNoteMarkers: google.maps.Marker[] = [];
  private mapNoteTooltip = new google.maps.InfoWindow();
  ticketCounty: string;
  ticketPlace: string;
  token: string;
  ticketWorkAreaText = 'Ticket Work Area';
  searchResultGroups = [];
  screen = false;
  searchValues: string[];
  searchValuesString: string;
  jsonSearchResults: RootObject;
  drawingManager: google.maps.drawing.DrawingManager;
  interactions: string[] = [
    'Point',
    'LineString',
    'Polygon'
  ];
  polycodes: TicketCode[];
  codeDiff: CodeDiffDisplay[];
  qaGeom: string = '';
  qaGeomCodes: TicketCode[];
  originalCodes: TicketCode[];
  returnCodes = true;
  drawOn = false;
  drawPolygons: MapPolygon[] = [];
  drawMarkers: google.maps.Marker[] = [];
  drawPolilines: google.maps.Polyline[] = [];
  markerSketchDialog;
  lineSketchDialog;
  polygonSketchDialog;
  sketchPolygons: google.maps.Polygon[] = [];
  sketchMarkers: google.maps.Marker[] = [];
  sketchPolilines: google.maps.Polyline[] = [];
  public              mouseGpsCoordinates: {latitude: number, longitude: number} = {latitude: undefined, longitude: undefined};
  private rightClickedMouseGpsCoordinates: {latitude: number, longitude: number};
  private searchGpsMarkers: google.maps.Marker[] = [];
  private callerSuppliedPolygon: google.maps.Polygon;
  private googleAutocompleteSessionToken: google.maps.places.AutocompleteSessionToken;
  /* Measure tool variables */
  public measureKiloMeter: number;
  public measureFeet: number;
  public measureMiles: number;
  public measureYard: number;
  public measureMeters: number;
  public measureMarkers: google.maps.Marker[] = [];
  public measureLine: google.maps.Polyline;
  public markerMeasureLine: google.maps.Polyline;
  public marker: google.maps.Marker;
  public markerPosition: google.maps.LatLng;
  public measureInfoWindow: google.maps.InfoWindow;
  public measureSketchMarker: google.maps.Marker;
  public measureToolDistance: string = '';
  public clickListener: any;

  constructor(public service: TicketService,
              public authService: AuthenticationService,
              public mapservice: MapService,
              public dialog: MatDialog,
              private localStorage: LocalStorage,
  ) {
    this.mapservice.getServiceAreaCodes.bind(this);
  }

  ngOnInit() {
    this.ticketCounty = this.service.ticket.workCounty;
    this.ticketPlace = this.service.ticket.workPlace;
    this.token = this.authService.token;
    this.originalCodes = this.service.ticket.ticketCodes;
    this.overlayComplete = this.overlayComplete.bind(this);
    this.getCodes = this.getCodes.bind(this);
    this.drawingManager = new google.maps.drawing.DrawingManager({
      drawingControl: true,
      drawingControlOptions: {
        position: google.maps.ControlPosition.TOP_LEFT,
        drawingModes: []
      },
    });
    const mapProp = {
      center: new google.maps.LatLng(this.service.ticket.workSite.latitude, this.service.ticket.workSite.longitude),
      zoom: 18,
      scrollwheel: true,
      disableDefaultUI: false,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      panControl: true,
      panControlOptions: {
        style: google.maps.ZoomControlStyle.SMALL,
        position: google.maps.ControlPosition.TOP_LEFT
      },
      zoomControl: true,
      zoomControlOptions: {
        style: google.maps.ZoomControlStyle.SMALL,
        position: google.maps.ControlPosition.LEFT_TOP
      },
      scaleControl: false,
      streetViewControl: true,
      streetViewControlOptions: {
        position: google.maps.ControlPosition.LEFT_BOTTOM
      },
      mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
        position: google.maps.ControlPosition.RIGHT_TOP,
        mapTypeIds: [
          google.maps.MapTypeId.ROADMAP,
          google.maps.MapTypeId.TERRAIN,
          google.maps.MapTypeId.SATELLITE,
          google.maps.MapTypeId.HYBRID
        ]
      }
    };
    this.map = new google.maps.Map(this.gmapElement.nativeElement, mapProp);
    this.addWorkAreaToMap(this.service.ticket.workSite.workArea, this.ticketWorkAreaText);
    this.drawingManager.setMap(this.map);

    this.map.addListener('mousemove', (event) => {
        this.setMouseGpsCoordinates(event.latLng.lat(), event.latLng.lng());
    });

    this.map.addListener('rightclick', (event) => {
        this.rightClickedMouseGpsCoordinates = {latitude: event.latLng.lat(), longitude: event.latLng.lng()};

        var rightClickMenuButton = document.getElementById('rightClickMenuButton');
            rightClickMenuButton.style.left = event.pixel.x + 'px';
            rightClickMenuButton.style.top  = event.pixel.y + 'px';

        setTimeout(() => this.rightClickMenuTrigger.openMenu(), 1); // Use a timeout to prevent browser right click (I don't know why it works)
    });

    this.loadMapNotesOnCurrentView();
  }

  setMouseGpsCoordinates = (longitude: number, latitude: number) => {
    this.mouseGpsCoordinates.latitude  = longitude;
    this.mouseGpsCoordinates.longitude = latitude;
  }

  addWorkAreaToMap(polygonWKT: string, polygonName?: string): void {
    var workAreaBounds : google.maps.LatLngBounds = new google.maps.LatLngBounds();
    const polygon: google.maps.Polygon = new google.maps.Polygon({
      paths: this.splitPolygonToPoints(polygonWKT),
      strokeColor: 'rgba(255, 204, 51, 1)',
      strokeOpacity: 1,
      strokeWeight: 1,
      fillColor: '#ee9900',
      fillOpacity: 0.7
    });

    polygon.addListener('mousemove', (event) => {
        this.setMouseGpsCoordinates(event.latLng.lat(), event.latLng.lng());
    });

    polygon.setMap(this.map);
    this.workAreaPolygon = new MapPolygon(polygonName, polygonWKT, polygon);
    this.workAreaPolygon.polygon.getPath().forEach(element => {
      workAreaBounds.extend(element);
    });
    this.map.fitBounds(workAreaBounds);

    polygon.addListener('rightclick', (event) => {
      this.rightClickedMouseGpsCoordinates = { latitude: event.latLng.lat(), longitude: event.latLng.lng() };

      const rightClickMenuButton = document.getElementById('rightClickMenuButton');
      rightClickMenuButton.style.left = event.ya.offsetX + 'px';
      rightClickMenuButton.style.top = event.ya.offsetY + 'px';
      // Use a timeout to prevent browser right click (I don't know why it works)
      setTimeout(() => this.rightClickMenuTrigger.openMenu(), 1);
    });

  }

  zoomToTicketWorkArea(): void {
    var workAreaBounds : google.maps.LatLngBounds = new google.maps.LatLngBounds();
    this.workAreaPolygon.polygon.getPath().forEach(element => {
      workAreaBounds.extend(element);
    });
    this.map.fitBounds(workAreaBounds);
  }

  splitPolygonToPoints(workArea: string): google.maps.LatLng[] {
    const regex = /\(([^()]+)\)/g;
    const rings: string[] = [];
    let pointsData: string[] = [];
    const workareaPoints: google.maps.LatLng[] = [];
    let results: string[] = [];
    while (results = regex.exec(workArea)) {
      rings.push(results[1]);
    }
    rings.forEach(element => {
      pointsData = element.split(',');
      pointsData.forEach(subelement => {
        const xy: string[] = subelement.split(' ');
        workareaPoints.push(new google.maps.LatLng(parseFloat(xy[1]), parseFloat(xy[0])));
      });
    });
    return workareaPoints;
  }

  searchSelect() {
    const dialogRef: MatDialogRef<SearchMapComponent, any> = this.dialog.open(SearchMapComponent, {
      width: '600px',
      disableClose: true,
      data: {
        county: this.ticketCounty,
        place: this.ticketPlace
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result !== 'Cancel') {
        this.searchValues = result.split(',');
        this.searchValuesString = '';
        if (this.searchValues[2] !== '') {
          this.searchValuesString += this.searchValues[2] + ' ';
        }
        if (this.searchValues[3] !== '') {
          this.searchValuesString += this.searchValues[3] + ' ';
        }
        this.searchValuesString += this.searchValues[4];
        if (this.searchValues[5] !== '') {
          this.searchValuesString += ' ' + this.searchValues[5];
        }
        if (this.searchValues[6] !== '') {
          this.searchValuesString += ' ' + this.searchValues[6];
        }
        if (this.searchValues[7] !== '') {
          this.searchValuesString += ' and ' + this.searchValues[7];
        }
        this.searchValuesString += ' in ' + this.searchValues[1] + ', ' + this.searchValues[0] + ' County';
        this.getSearchResults(this.searchValues[0],
          this.searchValues[1],
          this.searchValues[2],
          this.searchValues[3],
          this.searchValues[4],
          this.searchValues[5],
          this.searchValues[6],
          this.searchValues[7]);
        dialogRef.close();
      }
    });
  }

  getGoogleAutocompleteSessionToken = () => {
    if (!this.googleAutocompleteSessionToken)
      this.googleAutocompleteSessionToken = new google.maps.places.AutocompleteSessionToken();

    return this.googleAutocompleteSessionToken;
  }

  //search call to GC to get results
  getSearchResults(county: string,
                   place: string,
                   streetAddress: string,
                   streetPrefix: string,
                   streetName: string,
                   streetType: string,
                   streetSuffix: string,
                   intersection: string): void {
    this.screen = true;
    this.searchResultGroups = [];

    Observable.forkJoin(
      this.mapservice.getSearchResults(county, place, streetAddress, streetPrefix, streetName, streetType, streetSuffix, intersection, this.token, this.authService.currentState),
      this.mapservice.getBingSearchResults(county, place, streetAddress, streetPrefix, streetName, streetType, streetSuffix, intersection, this.token, 'bingSearch', this.authService.currentState),
      this.mapservice.getBingSearchResults(county, place, streetAddress, streetPrefix, streetName, streetType, streetSuffix, intersection, this.token, 'intersection', this.authService.currentState),
      this.mapservice.getGoogleSearchResults([county, place, streetAddress, streetPrefix, streetName, streetType, streetSuffix, intersection, this.authService.currentState].join(' '), this.getGoogleAutocompleteSessionToken()),
    )
      .subscribe(responses => {
        const [geocallResponse, bingStreetResults, bingIntersectionResults, googleSearchResults] = responses;

        geocallResponse.extension.forEach(element => {
          if (element.feature) {
            this.searchResultGroups.push({
              title: element.display,
              results: element.feature.map(feature => ({
                title: feature.display,
                type: element.display === 'Map Notes V3' ? 'map note' : 'feature',
                data: feature,
              })),
            });
          }
        });

        if (bingStreetResults.length) {
          this.searchResultGroups.push({
            title: 'Bing Best Results',
            results: bingStreetResults.map(feature => ({
              title: feature.display,
              type: 'feature',
              data: feature,
            })),
          });
        }

        if (bingIntersectionResults.length) {
          this.searchResultGroups.push({
            title: 'Bing Intersection Results',
            results: bingIntersectionResults.map(feature => ({
              title: feature.display,
              type: 'feature',
              data: feature,
            })),
          });
        }

        if (googleSearchResults.length) {
          this.searchResultGroups.push({
            title: 'Google Results',
            results: googleSearchResults.map(result => ({
              title: result.description,
              type: 'google',
              data: result,
            })),
          });
        }

        if (this.searchResultGroups.length) {
          this.addSearchResultToMap(this.searchResultGroups[0].results[0]);
          this.trigger.openMenu();
        }
        else {
          this.dialog.open(InfodialogComponent, {
            width: '500px',
            data: {
              title: 'No results',
              content: 'No results matched the given search'
            }
          });
        }

        this.screen = false;
      });
  }

  addSearchResultToMap = (selectedResult) => {
    if (selectedResult.type === 'feature')
      this.loadFeatureResultToMap(selectedResult.data);

    if (selectedResult.type === 'google')
      this.loadGoogleResultToMap(selectedResult.data);

    if (selectedResult.type === 'map note')
      this.loadMapNoteResultToMap(selectedResult.data);
  }

  loadMapNoteResultToMap = (mapNotefeature: Feature) => {
    const { geometry } = mapNotefeature;
    const locations: number[][] = [];

    if (geometry.match(/^POINT\((.+)\)$/)) {
      const [longitude, latitude] = geometry.match(/^POINT\((.+)\)$/)[1].split(' ').map((x: string) => +x);
      locations.push([longitude, latitude]);
    }
    else if (geometry.match(/^MULTIPOINT\((.+)\)$/)) {
      geometry.match(/^MULTIPOINT\((.*)\)$/)[1].split(',').forEach((location: string, index) => {
        const [longitude, latitude] = location.split(' ').map((x: string) => +x);
        locations.push([longitude, latitude]);
      });
    }

    if (locations.length) {
      this.clearMapNoteMarkers();
      this.clearSearchResultGeometries();
      this.screen = true;

      // If the user's selected result contains multiple map note points, we must call the API for each one
      Observable.forkJoin(
        ...locations.map(([longitude, latitude]) => this.mapservice.getMapNotes(this.token, this.authService.currentState, longitude, latitude))
      )
        .subscribe(responses => {
          const LatLngBounds = new google.maps.LatLngBounds();

          responses.forEach((mapNotes: MapNote[], index) => {
            const areNumbersSimilar = (x: number, y: number) => Number((x).toFixed(6)) === Number((y).toFixed(6));
            const [longitude, latitude] = locations[index]; // selected map note result

            // Because the map note API returns map notes of an area, we must find the map note(s) that matches the user's selection
            mapNotes.forEach(mapNote => {
              if (areNumbersSimilar(mapNote.longitude, longitude) && areNumbersSimilar(mapNote.latitude, latitude)) {
                LatLngBounds.extend({ lng: mapNote.longitude, lat: mapNote.latitude });
                this.addMapNoteMarker(mapNote.longitude, mapNote.latitude, mapNote.name, mapNote.remarks);
              }
            });
          });

          this.map.fitBounds(LatLngBounds);
          this.screen = false;
        });
    }
  }

  loadMapNotesOnCurrentView = () => {
    this.mapservice.getMapNotes(this.token, this.authService.currentState, this.map.getCenter().lng(), this.map.getCenter().lat()).subscribe(response => {
      response.forEach(mapNote => this.addMapNoteMarker(mapNote.longitude, mapNote.latitude, mapNote.name, mapNote.remarks));
    });
  }

  addMapNoteMarker = (lng: number, lat: number, name: string, description: string = '') => {
    const Marker = new google.maps.Marker({
      map: this.map,
      position: { lat, lng },
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        strokeColor: '#CC3333',
        strokeOpacity: 1,
        strokeWeight: 1,
        fillColor: '#CC3333',
        fillOpacity: 0.6,
        scale: 5,
      },
    });

    Marker.addListener('mouseover', (e) => {
      this.mapNoteTooltip.setContent(`
        <b>${name}</b></br>
        ${description}
      `);
      this.mapNoteTooltip.open(this.map, Marker);
    });

    this.mapNoteMarkers.push(Marker);
  }

  clearMapNoteMarkers = () => {
    this.mapNoteMarkers.forEach(Marker => Marker.setMap(null));
    this.mapNoteMarkers = [];
  }

  clearSearchResultGeometries = () => {
    this.searchMarkers.forEach(Marker => Marker.setMap(null));
    this.searchMarkers = [];

    this.searchPolilines.forEach(Polyline => Polyline.setMap(null));
    this.searchPolilines = [];

    this.searchPolygons.forEach(MapPolygon => MapPolygon.polygon.setMap(null));
    this.searchPolygons = [];
  }

  addSearchResultMarker = (lng: number, lat: number) => {
    this.searchMarkers.push(
      new google.maps.Marker({
        map: this.map,
        position: { lng, lat },
        icon: {
          path: google.maps.SymbolPath.CIRCLE,
          strokeColor: '#CC3333',
          strokeOpacity: 1,
          strokeWeight: 1,
          fillColor: '#CC3333',
          fillOpacity: 0.6,
          scale: 5,
        },
      })
    );
  }

  loadGoogleResultToMap = (googleResult) => {
    new google.maps.places.PlacesService(this.map).getDetails(
      {
        placeId: googleResult.place_id,
        fields: ['geometry'],
        sessionToken: this.getGoogleAutocompleteSessionToken(),
      },
      (response, status) => {
        this.clearSearchResultGeometries();
        this.addSearchResultMarker(response.geometry.location.lng(), response.geometry.location.lat());

        const LatLngBounds = new google.maps.LatLngBounds();
        LatLngBounds.extend({
          lng: response.geometry.location.lng(),
          lat: response.geometry.location.lat(),
        });
        this.map.fitBounds(LatLngBounds);

        // Autocomplete session is complete when a user selects a results (calls PlacesService.getDetails API)
        this.googleAutocompleteSessionToken = undefined;
      },
    );
  }

  loadFeatureResultToMap(feature: Feature): void {
    if (feature) {
      const LatLngBounds = new google.maps.LatLngBounds();
      this.clearSearchResultGeometries();

      if (feature.geometry.match(/^MULTIPOINT\(.+\)$/)) {
        feature.geometry.replace('MULTIPOINT(', '').replace(')', '').split(',').forEach(element => {
          const coordinates: string[] = element.split(' ');
          const lat = Number(coordinates[1]);
          const lng = Number(coordinates[0]);

          this.addSearchResultMarker(lng, lat);
          LatLngBounds.extend({ lat, lng });
        });

        this.map.fitBounds(LatLngBounds);
      }
      else if (feature.geometry.match(/^POINT\(.+\)$/)) {
        const coordinates: string[] = feature.geometry.replace('POINT(', '').replace(')', '').split(' ');
        const lat = Number(coordinates[1]);
        const lng = Number(coordinates[0]);

        this.addSearchResultMarker(lng, lat);
        LatLngBounds.extend({ lat, lng });
        this.map.fitBounds(LatLngBounds);
      }
      else if (feature.geometry.match(/^LINESTRING\(.+\)$/) || feature.geometry.match(/^MULTILINESTRING\(.+\)$/)) {
        const line: google.maps.Polyline = new google.maps.Polyline();
        line.setMap(this.map);
        line.setPath(this.splitPolygonToPoints(feature.geometry));
        line.setOptions({ strokeColor: '#CC3333', strokeOpacity: 0.8, strokeWeight: 5 });

        this.searchPolilines.push(line);

        line.getPath().forEach(element => LatLngBounds.extend(element));
        this.map.fitBounds(LatLngBounds);
      }
      else if (feature.geometry.match(/^POLYGON\(.+\)$/)) {
        const searchResultPolygon: google.maps.Polygon = new google.maps.Polygon();
        searchResultPolygon.setMap(this.map);
        searchResultPolygon.setPaths(this.splitPolygonToPoints(feature.geometry));
        searchResultPolygon.setOptions({
          strokeColor: '#CC3333',
          strokeOpacity: 1,
          strokeWeight: 1,
          fillColor: '#CC3333',
          fillOpacity: 0.75
        });

        const searchPolygon: MapPolygon = new MapPolygon('Search Poly', feature.geometry, searchResultPolygon);
        this.searchPolygons.push(searchPolygon);

        const polygonBounds: google.maps.LatLngBounds = new google.maps.LatLngBounds();
        searchPolygon.polygon.getPath().forEach(element => {
          polygonBounds.extend(element);
        });
        this.map.fitBounds(polygonBounds);
      }
    }
  }

  addDrawToMap(interaction: string): void {
    this.drawOn = true;
    this.drawingManager.setDrawingMode(null);
    this.drawingManager.setMap(null);
    this.drawingManager = new google.maps.drawing.DrawingManager();
    if (interaction === 'Point') {
      this.drawingManager.setDrawingMode(google.maps.drawing.OverlayType.MARKER);
      this.drawingManager.setOptions({ drawingControlOptions: { drawingModes: [] } });
      this.drawingManager.setOptions({
        markerOptions: {
          icon: {
            path: google.maps.SymbolPath.CIRCLE,
            scale: 5,
            strokeColor: '#47CEEA',
            strokeOpacity: 1,
            strokeWeight: 1,
            fillColor: '#F2F1ED',
            fillOpacity: 0.7
          },
        }
      });
      this.drawingManager.setMap(this.map);
    }
    if (interaction === 'LineString') {
      this.drawingManager.setDrawingMode(google.maps.drawing.OverlayType.POLYLINE);
      this.drawingManager.setOptions({ drawingControlOptions: { drawingModes: [] } });
      this.drawingManager.setOptions({
        polylineOptions: {
          strokeColor: '#47CEEA',
          strokeOpacity: 1,
          strokeWeight: 1
        }
      });
      this.drawingManager.setMap(this.map);
    }
    if (interaction === 'Polygon') {
      this.drawingManager.setDrawingMode(google.maps.drawing.OverlayType.POLYGON);
      this.drawingManager.setOptions({ drawingControlOptions: { drawingModes: [] } });
      this.drawingManager.setOptions({
        polygonOptions: {
          strokeColor: '#47CEEA',
          strokeOpacity: 2,
          strokeWeight: 2,
          fillColor: '#47CEEA',
          fillOpacity: 0.7
        }
      });
      this.drawingManager.setMap(this.map);
    }
    this.drawingManager.addListener('polygoncomplete', this.polygonComplete.bind(this));
    this.drawingManager.addListener('overlaycomplete', this.overlayComplete.bind(event));
  }

  addSketchToMap(interaction: string): void {
    this.drawOn = false;
    this.drawingManager.setDrawingMode(null);
    this.drawingManager.setMap(null);
    if (interaction === 'Point') {
      this.drawingManager.setDrawingMode(google.maps.drawing.OverlayType.MARKER);
      this.drawingManager.setOptions({ drawingControlOptions: { drawingModes: [] } });
      this.drawingManager.setOptions({
        markerOptions: {
          icon: {
            path: google.maps.SymbolPath.CIRCLE,
            scale: 5,
            strokeColor: '#468D34',
            strokeOpacity: 1,
            strokeWeight: 1,
            fillColor: '#468D34',
            fillOpacity: 0.7
          },
        }
      });
      this.drawingManager.setMap(this.map);
    }
    if (interaction === 'LineString') {
      this.drawingManager.setDrawingMode(google.maps.drawing.OverlayType.POLYLINE);
      this.drawingManager.setOptions({ drawingControlOptions: { drawingModes: [] } });
      this.drawingManager.setOptions({
        polylineOptions: {
          strokeColor: '#468D34',
          strokeOpacity: 1,
          strokeWeight: 1
        }
      });
      this.drawingManager.setMap(this.map);
    }
    if (interaction === 'Polygon') {
      this.drawingManager.setDrawingMode(google.maps.drawing.OverlayType.POLYGON);
      this.drawingManager.setOptions({ drawingControlOptions: { drawingModes: [] } });
      this.drawingManager.setOptions({
        polygonOptions: {
          strokeColor: '#468D34',
          strokeOpacity: 2,
          strokeWeight: 2,
          fillColor: '#468D34',
          fillOpacity: 0.7
        }
      });
      this.drawingManager.setMap(this.map);
    }
    this.drawingManager.addListener('polygoncomplete', this.addSketchName.bind(this));
    this.drawingManager.addListener('markercomplete', this.addSketchNameMarker.bind(this));
    this.drawingManager.addListener('polylinecomplete', this.addSketchNameLine.bind(this));
  }


  overlayComplete(overlay: google.maps.drawing.OverlayCompleteEvent): void {
    if (this.drawOn) {
      let wkt: string;
      if (overlay.type === google.maps.drawing.OverlayType.MARKER) {
        const position: google.maps.LatLng = overlay.overlay.get('position');
        wkt = 'POINT(';
        wkt += position.lng().toString() + ' ' + position.lat().toString();
        wkt += ')';
      }
      if (overlay.type === google.maps.drawing.OverlayType.POLYLINE) {
        wkt = 'LINESTRING(';
        const linePath = overlay.overlay.get('latLngs');
        const geometry: [] = linePath.g[0];
        geometry.forEach(element => {
          const latlng: google.maps.LatLng = element;
          wkt += latlng.lng().toString() + ' ' + latlng.lat().toString() + ',';
        });
        wkt = wkt.substring(0, wkt.length - 1) + ')';
      }
      if (wkt) {
        this.getCodes(wkt);
        overlay.overlay.setMap(null);
      }
    }
  }

  polygonComplete(event: google.maps.Polygon): void {
    if (this.drawOn) {
      let wkt: string;
      wkt = 'POLYGON(';
      const polygonPaths = event.getPaths();
      for (let i: number = 0; i < polygonPaths.getLength(); i++) {
        const polygonEachPath = polygonPaths.getAt(i);
        wkt += '(';
        for (let j = 0; j < polygonEachPath.getLength(); j++) {
          wkt += polygonEachPath.getAt(j).lng().toString() + ' ' + polygonEachPath.getAt(j).lat().toString() + ',';
        }
        wkt += polygonEachPath.getAt(0).lng().toString() + ' ' + polygonEachPath.getAt(0).lat().toString() + '),';
      }
      wkt = wkt.substring(0, wkt.length - 1) + ')';
      this.getCodes(wkt);
      event.setMap(null);
    }
  }

  getCodes(geometry: string): void {
    this.screen = true;
    this.mapservice.getServiceAreaCodes(geometry, this.token, this.authService.currentState).then(ticketCodes => {
      this.polycodes = ticketCodes.ticketCode;
      const origCodes = this.originalCodes.slice(0);
      this.codeDiff = new Array<CodeDiffDisplay>();
      this.polycodes.forEach(code => {
        const index: number = origCodes.findIndex(x => x.code === code.code);
        const temp: CodeDiffDisplay = new CodeDiffDisplay();
        temp.code = code.code;
        temp.organizationName = code.organizationName;
        temp.isAdded = code.isAdded;
        temp.isSuppressed = code.isSuppressed;
        temp.isSystemSuppressed = code.isSystemSuppressed;
        temp.organizationFacilities = code.organizationFacilities;
        if (index > -1) {
          temp.diff = 1;
          origCodes.splice(index, 1);
        } else {
          temp.diff = 0;
        }
        this.codeDiff.push(temp);
      });
      origCodes.forEach(code => {
        const temp: CodeDiffDisplay = new CodeDiffDisplay();
        temp.code = code.code;
        temp.organizationName = code.organizationName;
        temp.isAdded = code.isAdded;
        temp.isSuppressed = code.isSuppressed;
        temp.isSystemSuppressed = code.isSystemSuppressed;
        temp.organizationFacilities = code.organizationFacilities;
        temp.diff = -1;
        this.codeDiff.push(temp);
      });
      this.codeDiff.sort(function (a, b) {
        if (a.diff > b.diff) {
          return 1;
        } else if (a.diff < b.diff) {
          return -1;
        } else {
          if (a.organizationName > b.organizationName) {
            return 1;
          } else {
            return -1;
          }
        }
      });
      const getCodesDialog = this.dialog.open(MapdialogComponent, {
        width: '600px',
        data: {
          codeDiff: this.codeDiff,
          qaGeom: this.qaGeom
        }
      });
      getCodesDialog.afterClosed().subscribe(result => {
        if (result === 'saveMapping') {
          this.qaGeom = geometry;
          this.qaGeomCodes = this.polycodes;
          const workArea = new NewWorkArea();
          workArea.geom = this.qaGeom;
          workArea.codes = this.qaGeomCodes;
          this.workAreaChange.emit(workArea);
          this.addQAGeom();
        }
        if (this.qaGeom !== '') {
          this.returnCodes = false;
        }
      });
      this.screen = false;
    });
  }

  addQAGeom(): void {
    this.removeDrawings();
    const marker: google.maps.Marker = new google.maps.Marker();
    const line: google.maps.Polyline = new google.maps.Polyline();
    const polygon: google.maps.Polygon = new google.maps.Polygon();
    if (this.qaGeom.indexOf('POINT(') >= 0) {
      let position: string = this.qaGeom.replace('POINT(', '');
      position = position.replace(')', '');
      const coordinates: string[] = position.split(' ');
      const markerPosition: google.maps.LatLng = new google.maps.LatLng(Number(coordinates[1]), Number(coordinates[0]));
      marker.setMap(this.map);
      marker.setPosition(markerPosition);
      marker.setOptions({
        icon: {
          path: google.maps.SymbolPath.CIRCLE,
          scale: 5,
          strokeColor: '#47CEEA',
          strokeOpacity: 1,
          strokeWeight: 1,
          fillColor: '#F2F1ED',
          fillOpacity: 0.7
        },
      });
      this.drawMarkers.push(marker);
    }
    else if (this.qaGeom.indexOf('LINESTRING') >= 0) {
      line.setMap(this.map);
      line.setPath(this.splitPolygonToPoints(this.qaGeom));
      line.setOptions({ strokeColor: '#47CEEA', strokeOpacity: 1, strokeWeight: 1 });
      this.drawPolilines.push(line);
    }
    else if (this.qaGeom.indexOf('POLYGON') >= 0) {
      polygon.setMap(this.map);
      polygon.setPaths(this.splitPolygonToPoints(this.qaGeom));
      polygon.setOptions({
        strokeColor: '#47CEEA',
        strokeOpacity: 1,
        strokeWeight: 1,
        fillColor: '#F2F1ED',
        fillOpacity: 0.7
      });
      const drawPolygon: MapPolygon = new MapPolygon('Draw Poly', this.qaGeom, polygon);
      this.drawPolygons.push(drawPolygon);
    }
    else {
      return;
    }
  }

  removeQAGeom(): void {
    this.qaGeom = '';
    this.qaGeomCodes = new Array<TicketCode>();
    const workArea: NewWorkArea = new NewWorkArea();
    workArea.geom = this.qaGeom;
    workArea.codes = this.qaGeomCodes;
    this.workAreaChange.emit(workArea);
    this.removeDrawings();
  }

  removeDrawings(): void {
    if (this.drawMarkers.length > 0) {
      this.drawMarkers.forEach(element => {
        element.setMap(null);
      });
      this.drawMarkers = [];
    }
    else if (this.drawPolilines.length > 0) {
      this.drawPolilines.forEach(element => {
        element.setMap(null);
      });
      this.drawPolilines = [];
    }
    else if (this.drawPolygons.length > 0) {
      this.drawPolygons.forEach(element => {
        element.polygon.setMap(null);
      });
      this.drawPolygons = [];
    }
    else {
      return;
    }
  }
  addSketchName(polygon: google.maps.Polygon): void {
    if (!this.drawOn) {
      if (!this.polygonSketchDialog) {
        this.polygonSketchDialog = this.dialog.open(MapsketchdialogComponent, {
          width: '600px'
        });

        this.polygonSketchDialog.afterClosed().subscribe(result => {
          if (result !== 'Cancel') {
            const bounds: google.maps.LatLngBounds = new google.maps.LatLngBounds();
            polygon.getPath().forEach(element => bounds.extend(element));
            const marker: google.maps.Marker = new google.maps.Marker({
              position: bounds.getCenter(),
              map: this.map,
              label: {
                text: result,
                color: '#000',
                fontSize: '11px',
                fontWeight: 'bold'
              },
              icon: {
                path: google.maps.SymbolPath.CIRCLE,
                scale: 0.5
              },
            });
            this.sketchMarkers.push(marker);
          }
          this.polygonSketchDialog = undefined;
          this.sketchPolygons.push(polygon);
        });
      }
    }
  }

  addSketchNameMarker(marker: google.maps.Marker): void {
    if (!this.drawOn) {
      if (!this.markerSketchDialog) {
        this.markerSketchDialog = this.dialog.open(MapsketchdialogComponent, {
          width: '600px'
        });

        this.markerSketchDialog.afterClosed().subscribe(result => {
          if (result !== 'Cancel') {
            marker.setOptions({
              label: {
                text: result,
                color: '#000',
                fontSize: '11px',
                fontWeight: 'bold'
              }
            });
          }
          this.markerSketchDialog = undefined;
          this.sketchMarkers.push(marker);
        });
      }
    }
  }

  addSketchNameLine(line: google.maps.Polyline): void {
    if (!this.drawOn) {
      if (!this.lineSketchDialog) {
        this.lineSketchDialog = this.dialog.open(MapsketchdialogComponent, {
          width: '600px'
        });

        this.lineSketchDialog.afterClosed().subscribe(result => {
          if (result !== 'Cancel') {
            const bounds: google.maps.LatLngBounds = new google.maps.LatLngBounds();
            line.getPath().forEach(element => bounds.extend(element));
            const marker: google.maps.Marker = new google.maps.Marker({
              position: bounds.getCenter(),
              map: this.map,
              label: {
                text: result,
                color: '#000',
                fontSize: '11px',
                fontWeight: 'bold'
              },
              icon: {
                path: google.maps.SymbolPath.CIRCLE,
                scale: 0.5
              },
            });
            this.sketchMarkers.push(marker);
          }
          this.lineSketchDialog = undefined;
          this.sketchPolilines.push(line);
        });
      }
    }
  }

  removeSketches() {
    if (this.sketchMarkers.length > 0) {
      this.sketchMarkers.forEach(element => {
        element.setMap(null);
      });
      this.sketchMarkers = [];
    }
    if (this.sketchPolilines.length > 0) {
      this.sketchPolilines.forEach(element => {
        element.setMap(null);
      });
      this.sketchPolilines = [];
    }
    if (this.sketchPolygons.length > 0) {
      this.sketchPolygons.forEach(element => {
        element.setMap(null);
      });
      this.sketchPolygons = [];
    }
  }

  clearAll(): void {
    this.removeDrawings();
    this.removeSketches();
    this.searchGpsMarkers.forEach(marker => marker.setMap(null));
    this.searchGpsMarkers = [];
    if (this.callerSuppliedPolygon)
      this.callerSuppliedPolygon.setMap(null);
    this.removeMeasure();
    this.clearSearchResultGeometries();
    this.clearMapNoteMarkers();
  }

  sketchByXY = () => {
    this.dialog
      .open(SketchbyxydialogComponent, { width: '600px' })
      .afterClosed().subscribe((result: string) => {
        if (result != 'Cancel') {
          const splitted = result.split(',');
          const lat = +splitted[0];
          const lng = +splitted[1];

          this.searchGpsMarkers.push(
            new google.maps.Marker({
              map: this.map,
              position: { lat, lng },
              label: {
                text: `ref ${this.searchGpsMarkers.length + 1}`,
                fontWeight: 'bold',
              },
              icon: {
                path: google.maps.SymbolPath.CIRCLE,
                fillColor: '#468D34',
                fillOpacity: 0.9,
                strokeColor: '#468D34',
                strokeOpacity: 1,
                strokeWeight: 1,
                scale: 5,
              },
            })
          );

          this.map.panTo({ lat, lng });
          this.map.setZoom(18);
        }
      });
  }

  saveGPSCoordinatesToClipboard = () => {
    const temporaryInputElement = document.createElement('input');

    document.body.appendChild(temporaryInputElement);
    temporaryInputElement.setAttribute('value', this.rightClickedMouseGpsCoordinates.latitude + ', ' + this.rightClickedMouseGpsCoordinates.longitude);
    temporaryInputElement.select();
    document.execCommand('copy');
    document.body.removeChild(temporaryInputElement);
  }

  panToPolygon = (polygon: google.maps.Polygon) => {
    const bounds = new google.maps.LatLngBounds();
    polygon.getPath().forEach(path => { bounds.extend(path); });
    this.map.fitBounds(bounds);
  }

  getCallerSuppliedPoints = () => {
    if (this.callerSuppliedPolygon) {
      this.callerSuppliedPolygon.setMap(this.map);
      this.panToPolygon(this.callerSuppliedPolygon);
    }
    else {
      this.mapservice.getCallerSuppliedPoints(this.token, this.service.ticket.number, this.localStorage.getItem('currentState')).subscribe(response => {
        if (response && response[0].GeometryWkt) {
          this.callerSuppliedPolygon = new google.maps.Polygon({
            map: this.map,
            paths: this.splitPolygonToPoints(response[0].GeometryWkt),
            strokeColor: '#468D34',
            strokeOpacity: 1,
            strokeWeight: 2,
            fillColor: '#468D34',
            fillOpacity: 0.7,
          });

          this.panToPolygon(this.callerSuppliedPolygon);
        }
        else {
          this.dialog.open(InfodialogComponent, {
            width: '500px',
            data: {
              title: 'No Geometry Found',
              content: 'Caller supplied geometry was not found for this ticket'
            }
          });
        }
      });
    }
  }

  measureTool(): void {
    if (this.measureLine) {
      this.measureLine.setMap(null);
    }
    if (this.measureSketchMarker) {
      this.measureSketchMarker.setMap(null);
    }
    this.map.setOptions({
      disableDoubleClickZoom: true,
      gestureHandling: 'none',
      panControl: false,
      clickableIcons: false,
      draggableCursor: 'default'
    });
    this.measureLine = new google.maps.Polyline({
      strokeColor: '#47CEEA',
      strokeOpacity: 1,
      strokeWeight: 3,
      map: this.map,
      path: []
    });
    this.clickListener = google.maps.event.addListener(this.map, 'click', this.addMeasureMarker.bind(this));
  }
  addMeasureMarker(event) {
    this.markerPosition = event.latLng;
    let firstMarker;
    if (this.measureMarkers.length === 0) {
      firstMarker = new google.maps.Marker({
        map: this.map,
        position: event.latLng,
        icon: {
          path: google.maps.SymbolPath.CIRCLE,
          scale: 3,
          strokeColor: '#47CEEA',
        }
      });
    }
    if (this.marker) {
      this.marker.setMap(null);
    }
    this.marker = new google.maps.Marker({
      map: this.map,
      position: event.latLng,
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        scale: 3,
        strokeColor: '#47CEEA',
      },
      draggable: true
    });

    if (this.markerMeasureLine) {
      this.markerMeasureLine.setMap(null);
    }

    this.markerMeasureLine = new google.maps.Polyline({
      strokeColor: '#47CEEA',
      strokeOpacity: 1,
      strokeWeight: 3,
      map: this.map,
      path: []
    });
    if (firstMarker) {
      this.measureMarkers.push(firstMarker);
    }
    this.measureMarkers.push(this.marker);
    const measureDistance: string = this.startMeasure();
    if (this.measureInfoWindow) {
      this.measureInfoWindow.close();
    }
    this.measureInfoWindow = new google.maps.InfoWindow({
      pixelOffset: new google.maps.Size(0, -20)
    });
    this.measureInfoWindow.setPosition(event.latLng);
    this.measureInfoWindow.setContent(measureDistance);
    this.measureInfoWindow.open(this.map);
    google.maps.event.addListener(this.marker, 'drag', this.mouseMoveForMeasure.bind(this));
    google.maps.event.addListener(this.marker, 'dragend', this.addMeasureMarker.bind(this));
    google.maps.event.addListener(this.marker, 'dblclick', this.convertMeasureToSketch.bind(this));
    google.maps.event.removeListener(this.clickListener);
  }

  mouseMoveForMeasure(event): void {
    const coords: google.maps.LatLng[] = [];
    coords.push(this.markerPosition);
    coords.push(event.latLng);
    const allcoords: google.maps.LatLng[] = [];
    for (let i: number = 0; i < this.measureMarkers.length; i++) {
      allcoords.push(this.measureMarkers[i].getPosition());
    }
    allcoords.push(event.latLng);
    const measureMeters: number = google.maps.geometry.spherical.computeLength(allcoords);
    console.log(measureMeters);
    let calculatedDistance: string = '';
    if (measureMeters > 100) {
      //conversions from km to ft, km to mi, km to yd
      this.measureKiloMeter = (Math.round(measureMeters / 1000 * 100) / 100);
      this.measureFeet = this.measureKiloMeter * 3280.8;
      this.measureMiles = this.measureKiloMeter * 0.62137;
      this.measureYard = this.measureFeet / 3;
      calculatedDistance += this.measureKiloMeter.toFixed(3) + 'km';
      calculatedDistance += ' | ' + this.measureMiles.toFixed(3) + ' mi';
      calculatedDistance += ' | ' + this.measureFeet.toFixed(3) + ' ft';
      calculatedDistance += ' | ' + this.measureYard.toFixed(3) + ' yd';
    } else {
      //conversions from m to ft, m to mi, m to yd
      this.measureMeters = (Math.round(measureMeters * 100) / 100);
      this.measureFeet = this.measureMeters * 3.28;
      this.measureMiles = this.measureMeters * 0.00062137;
      this.measureYard = this.measureFeet / 3;
      calculatedDistance += this.measureMeters.toFixed(3) + 'm';
      calculatedDistance += ' | ' + this.measureMiles.toFixed(3) + ' mi';
      calculatedDistance += ' | ' + this.measureFeet.toFixed(3) + ' ft';
      calculatedDistance += ' | ' + this.measureYard.toFixed(3) + ' yd';
    }

    this.markerMeasureLine.setPath(coords);
    console.log(calculatedDistance);
    this.measureToolDistance = calculatedDistance;
    if (this.measureInfoWindow) {
      this.measureInfoWindow.close();
    }
    this.measureInfoWindow = new google.maps.InfoWindow({
      pixelOffset: new google.maps.Size(0, -20)
    });
    this.measureInfoWindow.setPosition(event.latLng);
    this.measureInfoWindow.setContent(calculatedDistance);
    this.measureInfoWindow.open(this.map);
  }
  startMeasure(): string {
    const coords = [];
    for (let i: number = 0; i < this.measureMarkers.length; i++) {
      coords.push(this.measureMarkers[i].getPosition());
      this.measureMarkers[i].setOptions({
        label: ''
      });
    }
    this.measureLine.setPath(coords);

    const measureMeters: number = google.maps.geometry.spherical.computeLength(coords);
    let calculatedDistance: string = '';
    if (measureMeters > 100) {
      // ** conversions from km to ft, km to mi, km to yd
      this.measureKiloMeter = (Math.round(measureMeters / 1000 * 100) / 100);
      this.measureFeet = this.measureKiloMeter * 3280.8;
      this.measureMiles = this.measureKiloMeter * 0.62137;
      this.measureYard = this.measureFeet / 3;
      calculatedDistance += this.measureKiloMeter.toFixed(3) + 'km';
      calculatedDistance += ' | ' + this.measureMiles.toFixed(3) + ' mi';
      calculatedDistance += ' | ' + this.measureFeet.toFixed(3) + ' ft';
      calculatedDistance += ' | ' + this.measureYard.toFixed(3) + ' yd';
    } else {
      // ** conversions from m to ft, m to mi, m to yd
      this.measureMeters = (Math.round(measureMeters * 100) / 100);
      this.measureFeet = this.measureMeters * 3.28;
      this.measureMiles = this.measureMeters * 0.00062137;
      this.measureYard = this.measureFeet / 3;
      calculatedDistance += this.measureMeters.toFixed(3) + 'm';
      calculatedDistance += ' | ' + this.measureMiles.toFixed(3) + ' mi';
      calculatedDistance += ' | ' + this.measureFeet.toFixed(3) + ' ft';
      calculatedDistance += ' | ' + this.measureYard.toFixed(3) + ' yd';
    }
    return calculatedDistance;
  }

  convertMeasureToSketch(event): void {
    let length;
    if (this.measureMiles < 1) {
      length = this.measureFeet.toFixed(0) + ' ft';
    } else {
      length = this.measureMiles.toFixed(2) + ' mi';
    }
    this.measureLine.setOptions({
      strokeColor: '#468D34',
      strokeOpacity: 1,
      strokeWeight: 1
    });
    const middleMarker = this.measureMarkers[Math.floor((this.measureMarkers.length - 1) / 2)];
    this.measureSketchMarker = new google.maps.Marker({
      position: middleMarker.getPosition(),
      map: this.map,
      label: {
        text: length,
        color: '#000',
        fontSize: '11px',
        fontWeight: 'bold'
      },
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        scale: 0.5
      },
    });
    this.measureMarkers.forEach(element => {
      element.setMap(null);
    });
    this.measureMarkers = [];
    if (this.measureInfoWindow) {
      this.measureInfoWindow.close();
    }
    this.measureToolDistance = '';
    this.map.setOptions({
      disableDoubleClickZoom: false,
      gestureHandling: 'greedy',
      panControl: true,
      clickableIcons: true,
      draggableCursor: ''
    });
  }
  removeMeasure(): void {
    if (this.measureMarkers.length > 0) {
      this.measureMarkers.forEach(element => {
        element.setMap(null);
      });
      this.measureMarkers = [];
    }
    if (this.measureLine) {
      this.measureLine.setMap(null);
    }
    if (this.measureSketchMarker) {
      this.measureSketchMarker.setMap(null);
    }
    this.map.setOptions({
      disableDoubleClickZoom: false,
      gestureHandling: 'greedy',
      panControl: true,
      clickableIcons: true,
      draggableCursor: ''
    });
  }
}
